module App.Functions {

    /**
     * Gets all unique items in a generic array
     */
    export var unique = <T>(array: T[]): T[] => {
        return array.reduce((p, c) => {
            if (p.indexOf(c) < 0) p.push(c);
            return p;
        }, []);
    }

    /**
     * Returns the first index from an array based on a given object    
    */
    export var getIndex = <T, U>(array: T[], val: U): number => {
        var indexOfVal = -1;
        for (var i = 0; i <= array.length - 1; i++) {
            if (array[i] == null && val == null) {
                return i;
            }
            if (array[i].equalsObj(val)) {
                indexOfVal = i;
                break;
            }
        }
        return indexOfVal;
    }

    /**
     * Gets the value of a location search paramater
     */
    export var getParameterByName = (name: string) => {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(window.location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    /**
     * Returns the intersected part of 2 arrays
     */
    export var intersect = (array1: any[], array2: any[]) => {
        var t;
        if (array2.length > array1.length) t = array2, array2 = array1, array1 = t; // indexOf to loop over shorter
        return array1.filter(e => {
            if (array2.indexOf(e) !== -1) return true;
        });
    }

    /**
     * Checks if a text contains html
     */
    export var isHtml = (text: string) => {
        return /<[a-zA-Z][\s\S]*[\/]?>/i.test(text);
    }

    /**
     * Group values of an array based on a function
     */
    export var groupBy = (array: any[], f: Function) => {
        var groups = {};
        array.forEach((o) => {
            var group = JSON.stringify(f(o));
            groups[group] = groups[group] || [];
            groups[group].push(o);
        });
        return Object.keys(groups).map((group) => {
            return groups[group];
        });
    }

    /**
     * Performs a test on a given storage to determine the availability of it
     */
    export var storageExists = (storage: Storage): boolean => {
        if (!storage)
            return false;
        try {
            storage.setItem('test', 'test');
            storage.removeItem('test');
            return true;
        } catch (e) {
            return false;
        }
    }

    export var setLicensePlateDash = (licensePlate: string): string => {
        var prev = ''
        var license = ''

        licensePlate = replaceAll(licensePlate, '-', '')

        for (var i = 0; i < licensePlate.length; i++) {

            if (prev != '' && (isNaN(+licensePlate[i]) != isNaN(+prev)))
                license += '-' + licensePlate[i]
            else
                license += licensePlate[i]

            prev = licensePlate[i]
        }

        return license
    }

    export var getUtmParams = (url: string): App.Interfaces.IUtmParam[] => {
        const matches = url.match(/utm_([a-zA-Z0-9_]+)=([^&]+)/g)

        const utmParams: App.Interfaces.IUtmParam[] = matches ? matches.map(match => {
            const [key, value] = match.split('=')
            const paramKey = key.split('utm_')[1] // Get the key after 'utm_'
            return {key: paramKey, value: value}
        }) : []
        return utmParams
    }

    export var getExpectYourCarText = (selectedReplacementVehicle: App.Interfaces.IReplacementVehicle,
        currentSettelmentReplacementVehicleText: App.Interfaces.IReplacementVehicleText[],
        globalReplacementVehicleText: App.Interfaces.IReplacementVehicleText[],
        isWaiting: boolean,
        time: string,
        pipelineName: string) => {

        if (currentSettelmentReplacementVehicleText == null) {
            currentSettelmentReplacementVehicleText = []
        }

        if (globalReplacementVehicleText == null) {
            globalReplacementVehicleText = []
        }

        const sources = currentSettelmentReplacementVehicleText.concat(globalReplacementVehicleText);

        let description = ""
        let productCode = selectedReplacementVehicle?.code ?? ""

        if (!isWaiting) {
            let desc: App.Interfaces.IReplacementVehicleText | null = null

            if (time && pipelineName == Constants.configuratorTypes.summerWinterCheckPipelineName) {
                desc = sources.find(x => x != null && x.code.toLowerCase() === productCode + 'timed')
            }
            else if (time) {
                desc = sources.find(x => x != null && x.code.toLowerCase() === productCode)
            }

            if (!desc) {
                desc = sources.find(x => x != null && x.code === productCode)
            }
            description = desc?.description ?? ""
        }

        if (!description) {
            description = time ? Constants.expectYourCarTextWithTime : Constants.expectYourCarText
        }
        if (time) {
            return String.format(description, time)
        }
        return description;
    }
}

/**
 * Formats a string based on index, the same as in .NET 2.0
 */
String.format = (formatString, ...args: any[]) => {
    return formatString.replace(/{(\d+)}/g, (match, number) => {
        return typeof args[number] != 'undefined'
            ? args[number]
            : match
            ;
    });
};

var equalsFunction = (currentVal, compareVal) => {
    if (currentVal && compareVal) {
        var hasProperties = false;
        var $type = $.type(currentVal);
        if ($type == 'object' || $type == 'array') {
            for (var prop in currentVal) {
                if (currentVal.hasOwnProperty(prop)) {
                    hasProperties = true;
                    if ((currentVal[prop] == null && compareVal[prop] != null) || (currentVal[prop] != null && !currentVal[prop].equalsObj(compareVal[prop])))
                        return false;
                }
            }
            for (var prop in compareVal) {
                if (compareVal.hasOwnProperty(prop)) {
                    hasProperties = true;
                    if ((currentVal[prop] == null && compareVal[prop] != null) || (currentVal[prop] != null && !currentVal[prop].equalsObj(compareVal[prop])))
                        return false;
                }
            }
        }
        if (!hasProperties) {
            if ($type === 'array')
                return (currentVal).length === (compareVal).length;

            if ($type === 'function' && $.type(compareVal) === 'function')
                return true;

            if ($type === "object" && $.type(compareVal) === "object")
                return true;

            if ($type === "string")
                return currentVal.toString() == compareVal;

            return currentVal == compareVal;
        }
        return true;
    }

    return currentVal == compareVal;
};

/**
     * Checks all values in an object to a compare object to determine if they are equal
     */
if (!Object.prototype["equalsObj"]) {
    Object.defineProperty(Object.prototype, 'equalsObj', {
        // Native javascript function because of usage of 'this'
        value: function (compareVal) {
            return equalsFunction(this, compareVal);
        },
        enumerable: false
    });
}

if (!Array.prototype.findIndex) {
    Array.prototype.findIndex = function (predicate) {
        'use strict';
        if (this == null) {
            throw new TypeError('Array.prototype.findIndex called on null or undefined');
        }
        if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
        }
        var list = Object(this);
        var length = list.length >>> 0;
        var thisArg = arguments[1];
        var value;

        for (var i = 0; i < length; i++) {
            value = list[i];
            if (predicate.call(thisArg, value, i, list)) {
                return i;
            }
        }
        return -1;
    };
}